<div class="h-screen w-full overflow-hidden">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="h-full w-full flex flex-col md:flex-row"
        autocomplete="off">
        <!-- Left panel: Intro (Adaptive Flex) -->
        <section class="hidden md:flex flex-1 relative h-full">
            <app-auth-intro badge="Sistema de Gestión Odontológica" title="La evolución de tu clínica"
                subtitle="Gestiona expedientes, finanzas y pacientes con la precisión que tu práctica merece."
                actionText="Solicitar tu demo"
                tip="Descubre cómo DENTIUM SYS puede transformar la gestión de tu clínica dental." [actionFn]="goToRegister"
                class="w-full"></app-auth-intro>
        </section>

        <!-- Right panel: Form Area (Constrained Flex) - Absolute Luminous Theme -->
        <section class="w-full md:w-[45%] lg:w-[40%] xl:w-[35%] flex flex-col h-full bg-white dark:bg-slate-900 
            relative overflow-hidden">
            <app-auth-header class="px-8 pt-4"></app-auth-header>

            <div class="flex-1 flex flex-col p-8 lg:p-14 xl:p-16">
                <!-- Master Content: Architectural Layout -->
                <div class="flex-1 flex flex-col justify-center w-full max-w-xl mx-auto">
                    <div class="space-y-12">
                        <!-- Welcoming Area -->
                        <div class="text-left animate-slide-up">
                            <div class="inline-flex items-center gap-2 mb-4 text-primary opacity-80">
                                <div class="w-6 h-[1.5px] bg-primary/40"></div>
                                <span class="text-[15px] font-black uppercase tracking-[0.4em]">Autenticación
                                    Segura</span>
                            </div>
                            <p
                                class="text-text-muted dark:text-slate-500 font-bold text-xs lg:text-[11px] leading-relaxed max-w-sm border-l-2 border-primary/10 pl-6">
                                Ingresa tus credenciales para administrar tu flujo clínico hoy.
                            </p>
                        </div>

                        <!-- Fields Grid -->
                        <div class="grid grid-cols-1 gap-6">

                            <app-input label="Usuario / Email Corporativo" placeholder="profesional o email"
                                formControlName="email" type="text" icon="mdi:account-outline" [required]="true"
                                [error]="loginForm.get('email')?.touched && loginForm.get('email')?.invalid ? 'Campo requerido' : ''">
                            </app-input>

                            <app-input label="Clave de Seguridad" type="password" placeholder="••••••••"
                                formControlName="password" [showToggle]="true" icon="mdi:lock-outline" [required]="true"
                                [error]="loginForm.get('password')?.touched && loginForm.get('password')?.invalid ? 'Mínimo 6 caracteres' : ''">
                            </app-input>


                            <!-- Utils & Submit -->
                            <div class="flex items-center justify-between pt-2">
                                <app-checkbox label="Recordar sesión" formControlName="remember"></app-checkbox>
                                <button (click)="goToForgotPassword()" type="button"
                                    class="text-[11px] font-black text-primary hover:text-foreground dark:hover:text-white transition-colors uppercase tracking-widest border-b border-primary/10 pb-0.5">
                                    ¿Olvidaste tu clave?
                                </button>
                            </div>

                            <!-- Final Submit -->
                            <div class="pt-6">
                                <app-button [fullWidth]="true" size="lg" type="submit" [loading]="loading()"
                                    iconRight="mdi:arrow-right"
                                    class="shadow-[0_15px_30px_rgba(74,144,226,0.1)] hover:shadow-primary/20 dark:hover:shadow-primary/30 transform active:scale-[0.98] transition-all rounded-xl py-5 text-base uppercase tracking-[0.2em] font-black">
                                    Entrar al Sistema
                                </app-button>
                            </div>
                        </div>

                        <!-- Error -->
                        <div *ngIf="errorMessage()"
                            class="p-5 bg-red-500/10 rounded-xl border border-red-500/20 flex items-center gap-4 text-xs font-black text-red-600 dark:text-red-400 animate-fade-in">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="3" class="shrink-0">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" y1="8" x2="12" y2="12" />
                                <line x1="12" y1="16" x2="12.01" y2="16" />
                            </svg>
                            {{ errorMessage() }}
                        </div>
                    </div>
                </div>


            </div>
            <!-- Wide Footer -->
            <div class="px-8 pb-4 flex justify-between items-center">
                <p class="text-[9px] font-black tracking-[0.3em] text-text-muted uppercase">
                    DENTIUM SYS Platform v1.0.4
                </p>
                <a routerLink="/setup"
                    class="text-[9px] font-black tracking-[0.3em] text-primary/40 hover:text-primary transition-colors uppercase">
                    Configuración Inicial
                </a>
            </div>
        </section>
    </form>
</div>